export class Administration {
    static readonly SSO_ENABLEDCHECK_USER_REQUEST =
        '/api/Administration/httpPost_SSOEnabledCheckUserRequest';

    static readonly ADD_USER_REQUEST =
        '/api/Administration/httpPost_CreateUserRequest';
    static readonly DISABLE_USER_REQUEST =
        '/api/Administration/httpPost_DisableUserRequest';
    static readonly ENABLE_USER_REQUEST =
        '/api/Administration/httpPost_EnableUserRequest';
    static readonly UPD_USER_REQUEST =
        '/api/Administration/httpPost_UpdateUserRequest';
    static readonly AUD_USER_DETAILS_BY_ID =
        '/api/Administration/httpPost_SetUserDetailsByID';

    static readonly ADD_DEL_USER_ADMIN_REPORTS =
        '/api/Administration/httpPost_AddDelUserAdminReports';
    static readonly ADD_DEL_USER_ADMIN_TENANTS =
        '/api/Administration/httpPost_AddDelUserAdminTenants';

    static readonly ADD_USER_TNTSRPTS_ADMIN =
        '/api/Administration/httpPost_AddUserTntsRptsAdmin';
    static readonly UPD_USER_TNTSRPTS_ADMIN =
        '/api/Administration/httpPost_UpdUserTntsRptsAdmin';
    static readonly DEL_USER_TNTSRPTS_ADMIN =
        '/api/Administration/httpPost_DelUserTntsRptsAdmin';
    static readonly GET_USER_ADMIN_MODELS =
        '/api/Administration/httpGet_GetUserAdminModels';

    static readonly GET_USER_ADMIN_MODEL_USING_ID =
        '/api/Administration/httpGet_GetUserAdminModelUsingID';
    static readonly GET_USER_ADMIN_REPORT_MODELS_USING_USER_ID =
        '/api/Administration/httpGet_GetUserAdminReportModelsUsingUserID';
    static readonly GET_USER_ADMIN_TENANT_MODELS_USING_USER_ID =
        '/api/Administration/httpGet_GetUserAdminTenantModelsUsingUserID';
    
    static readonly CREATE_REPORT_REQUEST =
        '/api/Administration/httpPost_CreateReportRequest';
    static readonly DISABLE_REPORT_REQUEST =
        '/api/Administration/httpPost_DisableReportRequest';
    static readonly ENABLE_REPORT_REQUEST =
        '/api/Administration/httpPost_EnableReportRequest';
    static readonly UPD_REPORT_REQUEST =
        '/api/Administration/httpPost_UpdateReportRequest';

    static readonly ADD_DEL_REPORT_ADMIN_USERS =
        '/api/Administration/httpPost_AddDelReportAdminUsers';
    static readonly ADD_DEL_REPORT_ADMIN_TENANTS =
        '/api/Administration/httpPost_AddDelReportAdminTenants';
    static readonly GET_REPORT_ADMIN_MODELS =
        '/api/Administration/httpGet_GetReportAdminModels';
    static readonly GET_REPORT_ADMIN_MODELS_EX =
        '/api/Administration/httpGet_GetReportAdminModelsEx';
    static readonly GET_REPORT_ADMIN_MODELS_WITH_CHILDREN =
        '/api/Administration/httpGet_GetReportAdminModelsWithChildren';

    static readonly GET_REPORT_ADMIN_USER_MODELS_USING_REPORT_ID =
        '/api/Administration/httpGet_GetReportAdminUserModelsUsingReportID';
    static readonly GET_REPORT_ADMIN_TENANT_MODELS_USING_REPORT_ID =
        '/api/Administration/httpGet_GetReportAdminTenantModelsUsingReportID';

    static readonly CREATE_TENANT_REQUEST =
        '/api/Administration/httpPost_CreateTenantRequest';
    static readonly DISABLE_TENANT_REQUEST =
        '/api/Administration/httpPost_DisableTenantRequest';
    static readonly ENABLE_TENANT_REQUEST =
        '/api/Administration/httpPost_EnableTenantRequest';
    static readonly UPD_TENANT_REQUEST =
        '/api/Administration/httpPost_UpdateTenantRequest';
    static readonly ADD_DEL_TENANT_ADMIN_USERS =
        '/api/Administration/httpPost_AddDelTenantAdminUsers';
    static readonly ADD_DEL_TENANT_ADMIN_REPORTS =
        '/api/Administration/httpPost_AddDelTenantAdminReports';
    static readonly GET_TENANT_ADMIN_MODELS_EX =
        '/api/Administration/httpGet_GetTenantAdminModelsEx';
    static readonly GET_TENANT_ADMIN_USER_MODELS_USING_TENANT_ID =
        '/api/Administration/httpGet_GetTenantAdminUserModelsUsingTenantID';
    static readonly GET_TENANT_ADMIN_REPORT_MODELS_USING_TENANT_ID =
        '/api/Administration/httpGet_GetTenantAdminReportModelsUsingTenantID';
    static readonly GET_ADD_USER_PRECHECK_ADMIN_MODEL = 
        '/api/Administration/httpPost_GetCreateUserPrecheckAdminModel';

    static readonly GET_FTPSERVER_ADMIN_MODELS = 
        '/api/Administration/httpGet_GetFTPServerAdminModels';
    static readonly AUD_FTPSERVER_DETAILS_BY_ID =
        '/api/Administration/httpPost_SetFTPServerDetailsByID';

    static readonly GET_TENANT_ADMIN_MODELS =
        '/api/Administration/httpGet_GetTenantAdminModels';
    static readonly AUD_TENANT_DETAILS_BY_ID =
        '/api/Administration/httpPost_SetTenantDetailsByID';

    static readonly GET_DATASET_ADMIN_MODELS =
        '/api/Administration/httpGet_GetDataSetAdminModels';
    static readonly AUD_DATASET_DETAILS_BY_ID =
        '/api/Administration/httpPost_SetDataSetDetailsByID';
    static readonly GET_DATASET_ADMIN_MODELS_WITH_CHILDREN =
        '/api/Administration/httpGet_GetDataSetAdminModelsWithChildren';

    static readonly GET_CHART_ADMIN_MODELS =
        '/api/Administration/httpGet_GetChartAdminModels';
    static readonly AUD_CHART_DETAILS_BY_ID =
        '/api/Administration/httpPost_SetChartDetailsByID';
    static readonly GET_CHART_ADMIN_MODELS_WITH_CHILDREN =
        '/api/Administration/httpGet_GetChartAdminModelsWithChildren';

    static readonly AUD_REPORT_DETAILS_BY_ID =
        '/api/Administration/httpPost_SetReportDetailsByID';
    static readonly GET_REPPORT_ADMIN_MODELS_WITH_CHILDREN =
        '/api/Administration/httpGet_GetReportAdminModelsWithChildren';

    static readonly GET_REPORT_INPUT_ADMIN_MODELS =
        '/api/Administration/httpGet_GetReportInputAdminModels';
    /*static readonly AUD_REPORT_INPUT_DETAILS_BY_ID =
        '/api/Administration/httpPost_SetReportInputDetailsByID';*/

    static readonly GET_DATASET_INPUT_ADMIN_MODELS =
        '/api/Administration/httpGet_GetDataSetInputAdminModels';
    /*static readonly AUD_DATASET_INPUT_DETAILS_BY_ID =
        '/api/Administration/httpPost_SetDataSetInputDetailsByID';*/

    static readonly GET_CORE_BRAND_ADMIN_MODELS =
        '/api/Reporting/httpGet_GetCoreBrandAdminModels';
    static readonly GET_CORE_TENANT_ADMIN_MODELS =
        '/api/Reporting/httpGet_GetCoreTenantAdminModels';
    static readonly GET_CORE_TYPE_ADMIN_MODELS =
        '/api/Reporting/httpGet_GetCoreTypeAdminModels';
    static readonly GET_CORE_FIELD_ADMIN_MODELS =
        '/api/Reporting/httpGet_GetCoreFieldAdminModels';

    static readonly ADHOC_REPORT_DEFINITION_LIST_REQUEST =
        '/api/Reporting/httpPost_GetAdHocReportDefinitionListUsingUserID';
    static readonly ADHOC_REPORT_DEFINITION_SET_REQUEST =
        '/api/Reporting/httpPost_SetAdHocReportDefinitionUsingUserID';
    static readonly ADHOC_REPORT_DEFINITION_GET_REQUEST =
        '/api/Reporting/httpPost_GetAdHocReportDefinitionUsingUserID';

    // replaced by workflow
    //static readonly REPORT_LINKAGE_TRACE_ROWS =
    //    '/api/Reporting/httpGet_GetReportLinkageTraceRows';
}

export default Administration;
